import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useNotesToolbarContext } from '../../context/notes/notes_toolbar_context';
import { useCreateLinkModal } from '../../hooks/notes/use_create_link_modal';
import { useLinkButton } from '../../hooks/notes/use_link_button';
import { styled } from '../../styles';
import { Button, ButtonRow, IconButton } from '../buttons';
import { WhiteInput } from '../inputs';
import { Box } from '../layout';
import { Modal } from '../modal/modal';
import { Header } from '../typography';
import { getFormatButtonIconFillColor, toolbarButtonStyles } from './styles';
export const LinkButton = ({ paddingLR }) => {
    const { isButtonDisabled, iconHoverFillColor, handleClick, modalState, isExistingLinkYn } = useLinkButton();
    return (_jsxs(LinkToolsetWrapper, { paddingLR: paddingLR, children: [_jsx(IconButton, { style: toolbarButtonStyles, iconName: "LinkEditorIcon", label: "LinkEditorIcon", disabled: isButtonDisabled, hoverFill: iconHoverFillColor, onClick: handleClick, fill: getFormatButtonIconFillColor(isExistingLinkYn), "data-testid": "notes-link-button" }), _jsx(CreateLinkModal, { isOpen: modalState.open })] }));
};
export const CreateLinkModal = ({ isOpen }) => {
    const { linkContext } = useNotesToolbarContext();
    const { modalState } = linkContext;
    const { handleValueChange, handleClose, handleCreateAndClose, getLinkButtonText } = useCreateLinkModal();
    // The insert button is disabled if there has been no change to the link/title or if there is no link on creation
    const isButtonDisabled = (() => {
        const titleChanged = modalState.title !== modalState.initialTitle;
        const linkChanged = modalState.initialLink !== modalState.href;
        if (linkContext.isExistingLinkYn) {
            return !titleChanged && !linkChanged;
        }
        return modalState.href === '';
    })();
    return (_jsxs(Modal, { isOpen: isOpen, onClose: handleClose, hideCloseButton: true, closeOnEscape: false, closeOnOverlayClick: false, styleOverride: {
            content: {
                width: '34.375rem',
            },
            overlay: {
                zIndex: 45,
            },
        }, children: [_jsx(HeaderContainer, { children: _jsx(Header, { children: "Insert Link" }) }), _jsx(WhiteInput, { name: "title", value: modalState.title, label: "Text to display", labelSize: "medium", labelColor: "dark", onChange: handleValueChange, "data-testid": "link-title-input" }), _jsx(WhiteInput, { name: "href", value: modalState.href, label: "Address", labelSize: "medium", labelColor: "dark", onChange: handleValueChange, "data-testid": "link-url-input" }), _jsxs(ModalButtonRow, { children: [_jsx(Button, { variant: "secondary", onClick: handleClose, children: "Cancel" }), _jsx(Button, { disabled: isButtonDisabled, onClick: handleCreateAndClose, "data-testid": "link-insert-update-delete-button", children: getLinkButtonText() })] })] }));
};
const HeaderContainer = styled.div({
    marginBottom: '1.2rem',
});
const LinkToolsetWrapper = styled(Box)(({ paddingLR, theme }) => ({
    paddingLeft: paddingLR,
    paddingRight: paddingLR,
    borderLeft: `0.063rem solid ${theme.colors.grey10}`,
}));
const ModalButtonRow = styled(ButtonRow)({
    marginTop: '3rem',
    width: '100%',
    justifyContent: 'flex-end',
});
//# sourceMappingURL=link_button.js.map